"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AbstractTextElement = _interopRequireDefault(require("UIComponents/elements/AbstractTextElement"));

var _escapeRegExp = require("../../../utils/escapeRegExp");

var InputHighlighter = function InputHighlighter(_ref) {
  var text = _ref.text,
      value = _ref.value;

  if (!value) {
    return text;
  }

  var parts = text.split(new RegExp("(" + (0, _escapeRegExp.escapeRegExp)(text) + ")", 'gi'));
  return _react.default.createElement(_react.Fragment, null, parts.map(function (part, index) {
    return _react.default.createElement(_AbstractTextElement.default, {
      key: index,
      weight: part.toLowerCase() === value.toLowerCase() ? 'bold' : 'regular'
    }, part);
  }));
};

InputHighlighter.propTypes = {
  text: _propTypes.default.string.isRequired,
  value: _propTypes.default.string
};
var _default = InputHighlighter;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/search/InputHighlighter.js
// module id = 761
// module chunks = 209 210 211 212